var _defs, _ellipse, _path, _path2, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack371({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 10.41,
    cy: 8,
    rx: 3.95,
    ry: 3.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.71,9.74V6.26h.57L9,8.72l.14.52c0-.13.08-.32.15-.56l.68-2.42h.51V9.74h-.36V6.83L9.24,9.74H8.9l-.83-3v3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,9.74V6.26h1a1.62,1.62,0,0,1,.56.07.89.89,0,0,1,.43.3,1.63,1.63,0,0,1,.28.56,2.62,2.62,0,0,1,.1.79,2.49,2.49,0,0,1-.17,1,1.21,1.21,0,0,1-.44.59,1.36,1.36,0,0,1-.71.17Zm.38-.41H12a1.06,1.06,0,0,0,.56-.12.75.75,0,0,0,.29-.39A2.34,2.34,0,0,0,13,8a1.86,1.86,0,0,0-.15-.83.76.76,0,0,0-.37-.41A1.35,1.35,0,0,0,12,6.67h-.59Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.73,
    y1: 2.68,
    x2: 13.28,
    y2: 5.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.54,
    y1: 10.87,
    x2: 5.09,
    y2: 13.32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.09,
    y1: 2.68,
    x2: 7.54,
    y2: 5.13
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 13.28,
    y1: 10.87,
    x2: 15.73,
    y2: 13.32
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.27,
    y1: 2.55,
    x2: 0.27,
    y2: 13.45
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 6.47,
    y1: 8,
    x2: 0.53,
    y2: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack371);
export default __webpack_public_path__ + "static/media/Symbol_pack_371.df1c9875b425b7abc8115ee6db3851f4.svg";
export { ForwardRef as ReactComponent };